import { configureStore } from '@reduxjs/toolkit';

import commsReducer from './slices/commsSlice';
import filtersReducer from './slices/filtersSlice';
import layoutReducer from './slices/layoutSlice';
import pubnubReducer from './slices/pubnubSlice';

export const store = configureStore({
  reducer: {
    layout: layoutReducer,
    filters: filtersReducer,
    pubnub: pubnubReducer,
    comms: commsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
